<template>
  <v-container>
    <v-row>
      <v-col class="xs-6" cols="6">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Pay.ReceiveInvoice.Title')}}</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col xs12 cols="12" class="members-setting-default-height">
              <!-- <v-row> -->
                <!-- <v-col xs12 md3 v-for="invoice in getProjectInvoices($route.params.project_id)" :key="invoice.id"> -->
                <div class="mini-invoice-row">
                  <MiniInvoice
                  v-for="invoice in getProjectInvoices($route.params.project_id)"
                  :key="invoice.id"
                  :invoice="invoice"
                  class="my-mini-invoice"
                  @click.native="setCurrentInvoice(invoice)"
                  />
                </div>
                <!-- </v-col> -->
              <!-- </v-row> -->
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col v-if="$route.params.invoice_id" class="xs-6" cols="6">
        <router-view></router-view>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
// import Invoice from '@/components/Invoice/Invoice.component.vue'
// import InvoiceContentEntry from '@/components/Invoice/InvoiceContentEntry.component.vue'
import MiniInvoice from '@/components/Invoice/MiniInvoice.component.vue'
// import DateCircle from '@/components/ProjectTaktPlan/DateCircle.component.vue'


import {
  mapGetters
} from 'vuex';
export default {
  components: {
    // WorkPackage,
    // Invoice,
    // InvoiceContentEntry,
    // DateCircle
    MiniInvoice
  },
  name: 'ProjectPayReceiveInvoice',
  data: function() {
    return {
      current_invoice: {}
    }
  },
  computed: {
    ...mapGetters('Project', [
      'getProjectInvoices'
    ]),
    ...mapGetters('Auth', [
      'getUser',
    ])
  },
  methods: {
    setCurrentInvoice(invoice){
      this.current_invoice = invoice;
      this.$router.push({
        name: 'ProjectPayCurrentInvoice',
        params: { invoice_id: invoice.id }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
// .members-setting-default-height {
//   height: 600px;
//   overflow-y: auto;
// }

.my-mini-invoice {
  margin: 5px;
}

.mini-invoice-row {
  display: flex;
  justify-content: left;
  width: 100%;
  flex-wrap: wrap;
}

</style>
